import produce from 'immer';
import { AnyAction } from 'redux';
import { RESERVE_HISTORY_DETAIL_STATE, RESERVE_HISTORY_DETAIL_STATE_INIT } from '../../../actions';

export type ReserveHistoryDetailStateType = {
  transitionTarget: boolean;
  historyId: string;
};

const initialState: ReserveHistoryDetailStateType = {
  transitionTarget: false,
  historyId: '',
};

const reserveHistoryDetailStateReducer = (state = initialState, action: AnyAction): ReserveHistoryDetailStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case RESERVE_HISTORY_DETAIL_STATE:
        dataState.transitionTarget = action.transitionTarget;
        dataState.historyId = action.historyId;
        break;
      case RESERVE_HISTORY_DETAIL_STATE_INIT:
        dataState.transitionTarget = initialState.transitionTarget;
        dataState.historyId = initialState.historyId;
        break;
      default:
        break;
    }
  });
};

export default reserveHistoryDetailStateReducer;
